import axios from "axios";
import { getTenant } from "./TENANT_CONFIGS";

export const setTenantRequestHeader = () => {
  let tenantId = getTenant();
  axios.defaults.headers.common["tenant"] = tenantId;
};

export const setUserTimezoneHeader = () => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  axios.defaults.headers.common["x-user-timezone"] = userTimezone;
};

export const setBackendUrlInProduction = () => {
if(process.env.NODE_ENV === 'production'){
   axios.defaults.baseURL = import.meta.env.VITE_SERVER_URL;
   axios.defaults.withCredentials = true;
}
 
};

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["x-auth-token"] = token;
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
};



// {
//     "title": "Write JSON File Node",
//     "create_time": 1723542552.652482,
//     "update_time": 1723542629.557775,
//     "mapping": {
//         "41d21d48-0b15-4c83-bff1-bff082888911": {
//             "id": "41d21d48-0b15-4c83-bff1-bff082888911",
//             "message": {
//                 "id": "41d21d48-0b15-4c83-bff1-bff082888911",
//                 "author": {
//                     "role": "system",
//                     "name": null,
//                     "metadata": {}
//                 },
//                 "create_time": null,
//                 "update_time": null,
//                 "content": {
//                     "content_type": "text",
//                     "parts": [
//                         ""
//                     ]
//                 },
//                 "status": "finished_successfully",
//                 "end_turn": true,
//                 "weight": 0.0,
//                 "metadata": {
//                     "is_visually_hidden_from_conversation": true
//                 },
//                 "recipient": "all",
//                 "channel": null
//             },
//             "parent": "aaa1053a-60f0-47e8-9eed-b4fa2404d9d0",
//             "children": [
//                 "aaa287d1-8a88-4075-b735-9dcc2a32af23"
//             ]
//         },
//         "aaa1053a-60f0-47e8-9eed-b4fa2404d9d0": {
//             "id": "aaa1053a-60f0-47e8-9eed-b4fa2404d9d0",
//             "message": null,
//             "parent": null,
//             "children": [
//                 "41d21d48-0b15-4c83-bff1-bff082888911"
//             ]
//         },
//         "aaa287d1-8a88-4075-b735-9dcc2a32af23": {
//             "id": "aaa287d1-8a88-4075-b735-9dcc2a32af23",
//             "message": {
//                 "id": "aaa287d1-8a88-4075-b735-9dcc2a32af23",
//                 "author": {
//                     "role": "user",
//                     "name": null,
//                     "metadata": {}
//                 },
//                 "create_time": 1723542552.656384,
//                 "update_time": null,
//                 "content": {
//                     "content_type": "text",
//                     "parts": [
//                         "write a new file in node js \ncontent is json data"
//                     ]
//                 },
//                 "status": "finished_successfully",
//                 "end_turn": null,
//                 "weight": 1.0,
//                 "metadata": {
//                     "request_id": "8b27cb385eea47c3-BOM",
//                     "message_source": null,
//                     "timestamp_": "absolute",
//                     "message_type": null
//                 },
//                 "recipient": "all",
//                 "channel": null
//             },
//             "parent": "41d21d48-0b15-4c83-bff1-bff082888911",
//             "children": [
//                 "624f69d5-7826-442a-8436-2708b403d03a"
//             ]
//         },
//         "624f69d5-7826-442a-8436-2708b403d03a": {
//             "id": "624f69d5-7826-442a-8436-2708b403d03a",
//             "message": {
//                 "id": "624f69d5-7826-442a-8436-2708b403d03a",
//                 "author": {
//                     "role": "assistant",
//                     "name": null,
//                     "metadata": {}
//                 },
//                 "create_time": 1723542571.809982,
//                 "update_time": null,
//                 "content": {
//                     "content_type": "model_editable_context",
//                     "model_set_context": "1. [2024-07-02]. User is a web developer.\n\n2. [2024-07-03]. User is running Monstache on a virtual machine and managing it with pm2.\n\n3. [2024-07-03]. User is facing issues with managing the `change-stream-namespaces` and `direct-read-namespaces` configurations, which can change.\n\n4. [2024-07-03]. User encountered issues running a bash script as a cron job.\n\n5. [2024-07-03]. User is using Windows WSL and their script path is /mnt/c/Users/rahul/Documents/github/monstacheServer/src/bashScripts.\n\n6. [2024-07-04]. User is working with a TOML configuration file structure for their project.\n\n7. [2024-07-06]. User is learning English.\n\n8. [2024-07-07]. User needs to run `pm2 restart all` if the content in the file is different.\n\n9. [2024-07-19]. User has a collection in MongoDB called `configs` with documents that can change.\n\n10. [2024-07-19]. User has two environments: staging and production.\n\n11. [2024-07-19]. Configs are updated on staging and then pushed to production.\n\n12. [2024-07-19]. User has an API to write all the configs from staging to production.\n\n13. [2024-07-19]. User wants to use some tools to visualize the changes going to production to make the config update process robust and solid.\n\n14. [2024-07-19]. User is considering Ansible or Terraform for automating configuration deployment.\n\n15. [2024-07-19]. User deploys their app on GCP App Engine using GitHub Actions and updates config using an API.\n\n16. [2024-07-26]. User is working on a sidebar component that expands from the right side of the screen and wants to make it sticky while ensuring compatibility with other potentially sticky elements above it.\n\n17. [2024-07-28]. User decided to use MongoDB ObjectIds for generating unique IDs in their app since they contain timestamps.\n\n18. [2024-07-31]. User is working on a content management system where users can submit content, and moderators can review and approve or send it back to the author. The system has different document statuses such as draft, editPublished, underMod, awaitingReview, published, and sentBack.\n\n19. [2024-08-01]. User's team hired someone to do a general security audit on all their digital assets/platforms.\n\n20. [2024-08-02]. User wants to make a drag and drop app for designing chatbot flows in their chatbot app built in Node.js, which currently requires a JSON config that is manually added in the code.\n\n21. [2024-08-02]. User thinks React Flow is the best option for building a drag-and-drop interface for designing chatbot flows in their Node.js app.\n\n22. [2024-08-03]. User has already made a chatbot in Node.js and is using switch conditions to represent different states of the chatbot.\n\n23. [2024-08-03]. User wants to make their chatbot scalable and robust and is interested in understanding how Botpress manages chatflow and what data structures they are using.\n\n24. [2024-08-03]. User will be integrating their chatbot app with different channels like WhatsApp.\n\n25. [2024-08-03]. User is considering RabbitMQ and Redis for their queue system in a chatbot app.\n\n26. [2024-08-04]. User is considering using Go to build the entire chatbot system.\n\n27. [2024-08-05]. User has a chatbot that uses Google Translate to translate to different languages and wants to implement logic to use static translations for some texts. If a static translation exists, it should be used; otherwise, Google Translate will be used. The chatbot uses a JSON config to manage messages.\n\n28. [2024-08-05]. User's chatbot JSON config messages can also include buttonText properties that need to be translated or localized.\n\n29. [2024-08-06]. User is interested in using Sentry with Node.js for error logging and monitoring.\n\n30. [2024-08-09]. User's chatbot messages are not simple one-word texts but are longer and more complex.\n\n31. [2024-08-10]. User is asking about whether the value of the `ref` field should be lowercase.\n\n32. [2024-08-13]. User is working with a string in JavaScript and needs to extract text between curly braces.",
//                     "repository": null,
//                     "repo_summary": null
//                 },
//                 "status": "finished_successfully",
//                 "end_turn": null,
//                 "weight": 1.0,
//                 "metadata": {
//                     "message_type": null,
//                     "model_slug": "gpt-4o",
//                     "default_model_slug": "auto",
//                     "parent_id": "aaa287d1-8a88-4075-b735-9dcc2a32af23",
//                     "request_id": "8b27cb385eea47c3-BOM",
//                     "timestamp_": "absolute",
//                     "model_switcher_deny": []
//                 },
//                 "recipient": "all",
//                 "channel": null
//             },
//             "parent": "aaa287d1-8a88-4075-b735-9dcc2a32af23",
//             "children": [
//                 "50e71ac3-0cd7-4cc8-9f10-724ca50f6199"
//             ]
//         },
//         "50e71ac3-0cd7-4cc8-9f10-724ca50f6199": {
//             "id": "50e71ac3-0cd7-4cc8-9f10-724ca50f6199",
//             "message": {
//                 "id": "50e71ac3-0cd7-4cc8-9f10-724ca50f6199",
//                 "author": {
//                     "role": "assistant",
//                     "name": null,
//                     "metadata": {}
//                 },
//                 "create_time": 1723542571.810089,
//                 "update_time": null,
//                 "content": {
//                     "content_type": "text",
//                     "parts": [
//                         "Here's an example of how you can write JSON data to a new file in Node.js:\n\n1. First, ensure you have Node.js installed.\n\n2. Create a new Node.js file, e.g., `writeJson.js`.\n\n3. Use the following code in the `writeJson.js` file:\n\n```javascript\nconst fs = require('fs');\n\n// Define your JSON data\nconst jsonData = {\n  name: \"John Doe\",\n  age: 30,\n  city: \"New York\"\n};\n\n// Convert JSON data to a string\nconst jsonString = JSON.stringify(jsonData, null, 2);\n\n// Write the JSON string to a file\nfs.writeFile('data.json', jsonString, (err) => {\n  if (err) {\n    console.error('Error writing file', err);\n  } else {\n    console.log('JSON data written to file successfully');\n  }\n});\n```\n\n### Explanation:\n- `require('fs')`: This imports the Node.js `fs` (File System) module, which provides file-handling functions.\n- `JSON.stringify(jsonData, null, 2)`: This converts the JSON object to a string. The `null` and `2` parameters format the JSON with 2-space indentation.\n- `fs.writeFile('data.json', jsonString, callback)`: This writes the JSON string to a file named `data.json`. The callback function handles any errors or confirms the successful write operation.\n\n4. Run the script using Node.js:\n```bash\nnode writeJson.js\n```\n\nThis will create a file named `data.json` in the same directory as the script, containing the JSON data."
//                     ]
//                 },
//                 "status": "finished_successfully",
//                 "end_turn": true,
//                 "weight": 1.0,
//                 "metadata": {
//                     "citations": [],
//                     "content_references": [],
//                     "gizmo_id": null,
//                     "message_type": null,
//                     "model_slug": "gpt-4o",
//                     "default_model_slug": "auto",
//                     "pad": "AAAAAAAAAAAAAAAAAAAAA",
//                     "parent_id": "624f69d5-7826-442a-8436-2708b403d03a",
//                     "finish_details": {
//                         "type": "stop",
//                         "stop_tokens": [
//                             200002
//                         ]
//                     },
//                     "is_complete": true,
//                     "request_id": "8b27cb385eea47c3-BOM",
//                     "timestamp_": "absolute",
//                     "model_switcher_deny": []
//                 },
//                 "recipient": "all",
//                 "channel": null
//             },
//             "parent": "624f69d5-7826-442a-8436-2708b403d03a",
//             "children": []
//         }
//     },
//     "moderation_results": [],
//     "current_node": "50e71ac3-0cd7-4cc8-9f10-724ca50f6199",
//     "plugin_ids": null,
//     "conversation_id": "558fb8c7-ef1d-4ad9-a7a7-d5d5c9b77146",
//     "conversation_template_id": null,
//     "gizmo_id": null,
//     "is_archived": false,
//     "safe_urls": [],
//     "default_model_slug": "auto",
//     "conversation_origin": null,
//     "voice": null,
//     "async_status": null
// }